import ImageViewer from './ImageViewer'
export default ImageViewer
